var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7,
  d: "m6.085 9.57 4.837 2.819m-.007-7.778-4.83 2.82m8.79-3.89a2.125 2.125 0 1 1-4.25 0 2.125 2.125 0 0 1 4.25 0M6.375 8.5a2.125 2.125 0 1 1-4.25 0 2.125 2.125 0 0 1 4.25 0m8.5 4.958a2.125 2.125 0 1 1-4.25 0 2.125 2.125 0 0 1 4.25 0"
})));
export { SvgShareIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/shareIcon.svg";